// src/hooks/iaDashboard/useAdvancedMetrics.js
import { useEffect, useState } from "react";
import {
  collection,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase/firebase";

/**
 * Hook de métricas avançadas:
 * - transferências hoje
 * - tempo médio de sessão (simples)
 * - sessões por avatar hoje
 */
export default function useAdvancedMetrics() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [transfersToday, setTransfersToday] = useState(0);
  const [avgSessionMinutes, setAvgSessionMinutes] = useState(0);
  const [sessionsPerAvatarToday, setSessionsPerAvatarToday] = useState([]);

  useEffect(() => {
    try {
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);

      const q = query(
        collection(db, "ai_sessoes"),
        where("createdAt", ">=", hoje)
      );

      const unsub = onSnapshot(
        q,
        (snap) => {
          const docs = snap.docs.map((d) => ({
            id: d.id,
            ...d.data(),
          }));

          // Transferências
          let totalTransfers = 0;
          docs.forEach((s) => {
            if (typeof s.transferCount === "number") {
              totalTransfers += s.transferCount;
            } else if (s.transferCountIncrement === true) {
              // fallback se ainda não houver cloud function
              totalTransfers += 1;
            }
          });
          setTransfersToday(totalTransfers);

          // Tempo médio de sessão (simples)
          let totalMinutes = 0;
          let counted = 0;
          docs.forEach((s) => {
            if (s.iniciouEm?.seconds && s.finalizadoEm?.seconds) {
              const startMs =
                s.iniciouEm.seconds * 1000 +
                (s.iniciouEm.nanoseconds || 0) / 1_000_000;
              const endMs =
                s.finalizadoEm.seconds * 1000 +
                (s.finalizadoEm.nanoseconds || 0) / 1_000_000;
              const diffMin = Math.max(0, (endMs - startMs) / 60000);
              totalMinutes += diffMin;
              counted += 1;
            }
          });
          setAvgSessionMinutes(
            counted > 0 ? Number((totalMinutes / counted).toFixed(1)) : 0
          );

          // Sessões por avatar (hoje)
          const map = {};
          docs.forEach((s) => {
            const avatar = s.avatarName || s.avatarId || "Avatar";
            map[avatar] = (map[avatar] || 0) + 1;
          });
          const agrupado = Object.entries(map).map(([avatar, count]) => ({
            avatar,
            count,
          }));
          setSessionsPerAvatarToday(agrupado);

          setLoading(false);
        },
        (err) => {
          console.error("Erro useAdvancedMetrics:", err);
          setError(err);
          setLoading(false);
        }
      );

      return () => unsub && unsub();
    } catch (err) {
      console.error("Erro useAdvancedMetrics (externo):", err);
      setError(err);
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    transfersToday,
    avgSessionMinutes,
    sessionsPerAvatarToday,
  };
}
